import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const salvarSilenciamentoCategoria = async (params) => {
  const uri = 'compras/materia-prima/notificacao-blacklist';
  const {data, status} = await api.post(uri, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const buscarQtdeCategoriasSilenciadas = async (params) => {
  const uri = 'compras/materia-prima/notificacao-blacklist/quantidade';
  const {data, status} = await api.get(uri, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.quantidade;
  }

  logout();
}

export const buscarCategoriasSilenciadas = async (params) => {
  const uri = 'compras/materia-prima/notificacao-blacklist/categorias';
  const {data, status} = await api.get(uri, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.categorias;
  }

  logout();
}

export const excluirCategoriasSilenciadas = async (params) => {
  const uri = 'compras/materia-prima/notificacao-blacklist/categorias/exclusao';
  const {data, status} = await api.post(uri, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
